import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

import type { Theme } from '@bizzabo/design-system';

const UserInfoSkeleton = () => {
    const classes = useStyles();

    return (
        <>
            <div className={cn(classes.info)}>
                <div className={cn(classes.animated, classes.icon)} />
                <div className={classes.header}>
                    <div className={cn(classes.animated, classes.text, classes.text50)} />
                    <div className={cn(classes.animated, classes.text, classes.text60)} />
                </div>
            </div>
            <div className={cn(classes.animated, classes.text)} />
            <div className={cn(classes.animated, classes.text, classes.text80)} />
            <div className={cn(classes.animated, classes.text, classes.text90)} />
            <div className={cn(classes.animated, classes.cta)} />
        </>
    );
};

const useStyles = makeStyles(
    (theme: Theme) => ({
        info: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: 12,
        },
        icon: {
            width: 50,
            height: 50,
            borderRadius: '50%',
            backgroundColor: theme.palette.greys[300],
            flexShrink: 0,
        },
        header: {
            marginLeft: 8,
            flexBasis: '100%',
            '& > div:last-of-type': {
                marginBottom: 0,
            },
        },
        text: {
            backgroundColor: theme.palette.greys[300],
            height: 12,
            width: '100%',
            marginBottom: 6,
            borderRadius: 4,
        },
        text90: {
            width: '90%',
        },
        text80: {
            width: '80%',
        },
        text60: {
            width: '60%',
        },
        text50: {
            width: '50%',
        },
        cta: {
            backgroundColor: theme.palette.greys[300],
            height: 26,
            width: 80,
            margin: '20px 0 0 auto',
            borderRadius: 32,
        },
        animated: {
            position: 'relative',
            overflow: 'hidden',
            WebkitMaskImage: '-webkit-radial-gradient(white, black)',

            '&:after': {
                content: '""',
                animation: '$waveKeyframe 1.6s linear 0.5s infinite',
                background: `linear-gradient(90deg, transparent, #40404020, transparent)`,
                position: 'absolute',
                transform: 'translateX(-100%)',
                bottom: 0,
                left: 0,
                right: 0,
                top: 0,
            },
        },
        '@keyframes waveKeyframe': {
            '0%': {
                transform: 'translateX(-100%)',
            },
            '50%': {
                transform: 'translateX(100%)',
            },
            '100%': {
                transform: 'translateX(100%)',
            },
        },
    }),
    { classNamePrefix: 'people-user-info-skeleton' }
);

export default UserInfoSkeleton;
